export default class RecipientName {

  private readonly _value: string;

  constructor(value: string) {
    this._value = value;
  }

  public isEqualTo(other: RecipientName): boolean {
    return this.value === other?.value;
  }

  public get value(): string {
    return this._value;
  }

  public static get Prototype(): RecipientName {
    return new RecipientName("");
  }

  public fromJSON(value: string): RecipientName {
    return new RecipientName(value);
  }
  public toJSON(): string {
    return this.value;
  }
  public clone(): RecipientName {
    return new RecipientName(this.value);
  }
}
